/**
 * Resolve the base URL for backend API calls.
 *
 * Deployed (any non-localhost browser): always use the current origin's `/api`,
 * so the frontend talks to its own host's backend regardless of the build-time
 * `VITE_API_URL`. Every droplet serves the API same-origin under `/api` (the
 * frontend nginx proxies `/api` to the backend), so this is correct for both
 * production and staging. It also prevents a bundle that was built with the
 * wrong `VITE_API_URL` (e.g. a staging build baked with the production URL)
 * from calling the other environment's API and being blocked by CORS.
 *
 * Local dev (localhost / 127.0.0.1 browser): use `VITE_API_URL` so the dev
 * frontend can reach the dev backend (default `http://localhost:3000`).
 */
export function resolveApiBaseUrl(): string {
    if (typeof window !== "undefined" && window.location?.hostname) {
        const host = window.location.hostname;
        const isLocalHost = host === "localhost" || host === "127.0.0.1";
        if (!isLocalHost && window.location.origin) {
            return `${window.location.origin.replace(/\/+$/, "")}/api`;
        }
    }
    const raw = String(import.meta.env.VITE_API_URL || "").trim().replace(/\/+$/, "");
    return raw || "http://localhost:3000";
}
